<template>
  <div class="order-info-form">
    <service-form :option="option" v-model="form" ref="form" hidden>
      <template slot="senderAreaId">
        <address-select v-model="initSenderAddressData" @changeValue="changeAddress($event, true)" />
      </template>
      <template slot="senderBtn">
        <el-button class="" type="primary" size="mini" @click="networkQuery(1)">{{$lang('网点查询')}}</el-button>
      </template>
      <template slot="receiverAreaId">
        <address-select v-model="initReceiverAddressData" @changeValue="changeAddress" />
      </template>
      <template slot="receiverBtn">
        <el-button type="primary" size="mini" @click="networkQuery(2)">{{$lang('网点查询')}}</el-button>
      </template>
      <template slot="signReceipt">
        <el-switch v-model="signReceipt" />
      </template>
    </service-form>

    <!-- 网点信息弹窗 -->
    <el-dialog :title="$lang('网点信息')" :visible.sync="dialogVisible" :before-close="handleClose" width="35%">
      <el-form class="el-form-detail"
              ref="sizeForm"
              :inline="true"
              label-position="left"
              label-suffix=" :">
          <div>
            <el-form-item :label="$lang('网点名称')">
              {{ informationList.name ? informationList.name : '--'}}
            </el-form-item>
            <el-form-item :label="$lang('邮编')">
              {{ informationList.zipCode ? informationList.zipCode : '--'}}
            </el-form-item>
            <el-form-item :label="$lang('客服联系人')">
              {{ informationList.customerServicePrincipal ? informationList.customerServicePrincipal : '--'}}
            </el-form-item>
            <el-form-item :label="$lang('客服电话')">
              {{ informationList.customerServiceTelephone ? informationList.customerServiceTelephone : '--'}}
            </el-form-item>
            <el-form-item :label="$lang('业务联系人')">
              {{ informationList.businessPrincipal ? informationList.businessPrincipal : '--'}}
            </el-form-item>
            <el-form-item :label="$lang('业务电话')">
              {{ informationList.businessTelephone ? informationList.businessTelephone : '--'}}
            </el-form-item>
            <el-form-item :label="$lang('派送范围')"
                          style="width: 100%;">
              {{ informationList.deliveryRange ? informationList.deliveryRange : '--'}}
            </el-form-item>
            <el-form-item :label="$lang('不派送范围')"
                          style="width: 100%;">
              {{ informationList.nonDrRange ? informationList.nonDrRange : '--'}}
            </el-form-item>
            <el-form-item :label="$lang('备注')"
                          style="width: 100%;">
              {{ informationList.remark ? informationList.remark : '--'}}
            </el-form-item>
          </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{$lang('关闭')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { RULES } from '@public/utils/validators'
import { RecordSheet } from './pool'
export default {
  name: 'OrderInfoForm',
  data() {
    return {
      form: {},
      goodsTypeOptions: [],
      signReceipt: false,
      dialogVisible: false,
      informationList: {}, // 网点信息数据
      initReceiverAddressData: {},
      initSenderAddressData: {}
    }
  },
  watch: {
    initReceiverAddressData: {
      deep: true,
      handler(obj) {
        this.form.receiverProvinceId = obj.provinceId
        this.form.receiverProvinceName = obj.provinceName
        this.form.receiverCityId = obj.cityId
        this.form.receiverCityName = obj.cityName
        this.form.receiverAreaId = obj.areaId
        this.form.receiverAreaName = obj.areaName
      }
    },
    initSenderAddressData: {
      deep: true,
      handler(obj) {
        this.form.senderProvinceId = obj.provinceId
        this.form.senderProvinceName = obj.provinceName
        this.form.senderCityId = obj.cityId
        this.form.senderCityName = obj.cityName
        this.form.senderAreaId = obj.areaId
        this.form.senderAreaName = obj.areaName
      }
    }
  },
  computed: {
    option() {
      const self = this
      return {
        emptyBtn: false,
        column: [
          {
            label: '寄件人',
            prop: 'senderName',
            rules: [RULES.required]
          },
          {
            label: '寄件人手机',
            prop: 'senderMobilePhone',
            rules: [RULES.required]
          },
          {
            label: '寄件人地址',
            prop: 'senderAreaId',
            flex: true,
            right: '5px',
            rules: [RULES.required]
          },
          {
            label: '',
            prop: 'senderDetailedAddress',
            right: '5px',
            placeholder: '请输入详细地址',
            rules: [RULES.required]
          },
          {
            label: '',
            right: '0px',
            prop: 'senderBtn'
          },
          {
            label: '收件人',
            prop: 'receiverName'
          },
          {
            label: '收件人手机',
            prop: 'receiverMobilePhone'
          },
          {
            label: '收件人地址',
            prop: 'receiverAreaId',
            right: '5px',
            flex: true
          },
          {
            label: '',
            prop: 'receiverDetailedAddress',
            right: '5px',
            placeholder: '请输入详细地址'
          },
          {
            label: '',
            right: '0px',
            prop: 'receiverBtn'
          },
          {
            label: '物品类型',
            prop: 'goodsTypeCode',
            type: 'select',
            props: {
              value: 'code',
              label: 'name'
            },
            dicData: this.goodsTypeOptions,
            rules: [RULES.required]
          },
          {
            label: '重量(kg)',
            prop: 'packageChargeWeight',
            placeholder: '请输入重量',
            rules: [RULES.isNumber, RULES.numTwoFloat, { validator: this.validatorWeight, trigger: ['change', 'blur'] }, RULES.required],
            change({ value }) {
              self.form.packageTotalWeight = value
              if (self.form.receiverAreaId && self.form.senderAreaId && self.form.packageTotalWeight) {
                self.getForecast()
              }
              if (value === '') {
                self.form.forecast = 0
              }
            }
          },
          // {
          //   label: '是否回签单',
          //   prop: 'signReceipt'
          // },
          {
            label: '预估费用',
            disabled: true,
            prop: 'forecast'
          }
        ]
      }
    }
  },
  // watch: {
  //   'form.packageChargeWeight': {
  //     handler(val) {
  //       console.log(val)
  //       this.form.packageTotalWeight = val
  //     }
  //   }
  // },
  methods: {
    validatorWeight(rule, value, callback) {
      if (value > 30) {
        callback(new Error(this.$lang('重量最多30KG')))
      }
      if (value <= 0 && value !== '') {
        callback(new Error(this.$lang('重量不能小于等于0')))
      }
      callback()
    },
    resetFields() {
      this.form = {}
      this.$refs.form.resetFields()
    },
    changeGoodsType(val) {
      const { name } = this.goodsTypeOptions.find(item => item.code === val) || {}
      this.form.goodsTypeName = name
    },
    // 预估费用
    async getForecast() {
      const form = this.form
      const params = {
        originProviderId: form.senderProvinceId,
        originCityId: form.senderCityId,
        originAreaId: form.senderAreaId,
        destinationProviderId: form.receiverProvinceId,
        destinationCityId: form.receiverCityId,
        destinationAreaId: form.receiverAreaId,
        packageChargeWeight: this.form.packageTotalWeight
      }
      const { code, data, msg } = await RecordSheet.getEstimatedFreight(params)
      if (code === 1) {
        this.form.forecast = data
      } else {
        this.$message.error(msg)
      }
    },
    // 网点查询
    networkQuery(type) {
      if (type === 1 && this.initSenderAddressData && this.form.senderDetailedAddress) {
        console.log(this.initSenderAddressData);
        const params = {
          ...this.initSenderAddressData,
          details: this.form.senderDetailedAddress
        }
        return this.getNetworkDetail(params)
      } else if (type === 2 && this.initReceiverAddressData && this.form.receiverDetailedAddress) {
        const params = {
          ...this.initReceiverAddressData,
          details: this.form.receiverDetailedAddress
        }
        return this.getNetworkDetail(params)
      } else {
        this.$message.warning(this.$lang('请输入完整地址！'))
      }
    },
    // 查询网点信息
    async getNetworkDetail(params) {
      const { code, data, msg } = await RecordSheet.getNetworkInfor(params)
      if (code === 1) {
        this.informationList = data
        this.dialogVisible = true
      } else {
        this.$message.error(msg)
      }
    },
    handleClose() {
      this.dialogVisible = false
    },
    getGoodsType() {
      RecordSheet.reqSrticle().then(({ code, data }) => {
        // 请求成功且有数据
        if (code === 1 && data.records) {
          this.goodsTypeOptions = data.records
        }
      })
    },
    changeAddress({ senderAreaId }, isSender) {
      if (isSender) {
        if (senderAreaId) {
          this.$refs.form.validateField('senderAreaId')
        }
      }
    },
    async submitForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.form.signReceipt = this.signReceipt ? 1 : 0
            resolve(this.form)
          } else {
            resolve()
          }
        })
      })
    }
  },
  mounted() {
    this.getGoodsType()
  }
}
</script>
